import React, { useContext } from 'react';
import {
  SideNav,
  SideNavItems,
  SideNavLink,
} from 'carbon-components-react/lib/components/UIShell';

import { UIShellContext } from '../../contexts/UIShellContext';

const UIShellSiderRight = () => {
  const { showSideMenuRightHelp } = useContext(UIShellContext);

  return (
    <React.Fragment>
      {showSideMenuRightHelp && (
        <SideNav
          id="side-nav-right-Help"
          className="side-nav-right"
          aria-label="Side Navigation Help">
          <SideNavItems>
            <a
              className="side-nav-right-external-link"
              href="https://www.ibm.com/privacy/us/en/"
              target="_blank"
              rel="noopener noreferrer">
              <SideNavLink>Privacy</SideNavLink>
            </a>
            <a
              className="side-nav-right-external-link"
              href="https://www.ibm.com/legal"
              target="_blank"
              rel="noopener noreferrer">
              <SideNavLink>Terms of Use</SideNavLink>
            </a>
          </SideNavItems>
        </SideNav>
      )}
    </React.Fragment>
  );
};

export default UIShellSiderRight;
